/**
 * Situação da licença para o menu Conta e a página Licença (proposta B do Claude Design,
 * 25/10/2026). Os dias contam pelo calendário: "vence hoje" é a data de fim igual a hoje.
 *  - ativa; perto de vencer (menos de 4 dias); vence hoje; vencida;
 *  - assinatura (mais de 1 ano pela frente) e vitalícia (mais de 10 anos), sem data;
 *  - teste (`demo`, decisão 110): sem data, porque no teste a captura não vence.
 */
import { isTrial } from '../../lib/entitlements';
import type { Entitlements } from '../../types/session';
const DAY = 24 * 60 * 60 * 1000;

export type LicenseKind =
  'active' | 'ending' | 'today' | 'expired' | 'subscription' | 'lifetime' | 'trial' | 'none';

export interface LicenseView {
  kind: LicenseKind;
  /** Data de fim (ativa, perto de vencer, hoje e vencida). */
  until: Date | null;
  /** Dias de calendário até o fim (0 = hoje). */
  days: number;
}

function startOfDay(date: Date): number {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
}

export function licenseView(
  session:
    | { demo?: boolean; expiredAt?: string; entitlements?: Pick<Entitlements, 'state'> }
    | null
    | undefined,
  now = new Date(),
): LicenseView {
  if (isTrial(session)) return { kind: 'trial', until: null, days: 0 };
  const until = session?.expiredAt ? new Date(session.expiredAt) : null;
  if (!until || Number.isNaN(until.getTime())) return { kind: 'none', until: null, days: 0 };
  const left = until.getTime() - now.getTime();
  if (left > 365 * DAY * 10) return { kind: 'lifetime', until: null, days: 0 };
  if (left >= 366 * DAY) return { kind: 'subscription', until: null, days: 0 };
  if (left <= 0) return { kind: 'expired', until, days: 0 };
  const days = Math.round((startOfDay(until) - startOfDay(now)) / DAY);
  if (days <= 0) return { kind: 'today', until, days: 0 };
  return { kind: days < 4 ? 'ending' : 'active', until, days };
}

/** Renovar é a ação principal (amarela) quando faltam menos de 4 dias ou já venceu. */
export function renewIsUrgent(kind: LicenseKind): boolean {
  return kind === 'ending' || kind === 'today' || kind === 'expired';
}
